import {apiClient, apiAdminClient} from './apiClient';
import {Product, ProductDetail, User, adminProduct} from '../types/product';

export const fetchProducts = async (): Promise<Product[]> => {
    const data = await apiClient<{ products: Product[] }>('/products');
    return data.products;
};

export const fetchProductById = async (id: string): Promise<ProductDetail> => {
    const data = await apiClient<{ product: ProductDetail }>(`/product/${id}`);
    return data.product;
};

export const fetchBuyProduct = async (id: string, type: string = 'self'): Promise<void> => {
    await apiClient(`/product/pay`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({id, type}),
    });
};

export const fetchUser = async (): Promise<User> => {
    const data = await apiClient<{ user: User }>(`/user`);
    return data.user;
};

export const fetchPurchasedWithoutReviews = async (): Promise<Product[]> => {
    const data = await apiClient<{ products: Product[] }>('/reviews');
    return data.products;
};

export const fetchPurchasedProducts = async (): Promise<Product[]> => {
    const data = await apiClient<{ products: Product[] }>('/products/purchased');
    return data.products;
};

export const toggleFavorite = async (productId: string): Promise<void> => {
    await apiClient('/favorite/', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({productId: productId}),
    });
};

export const submitReview = async (reviewData: {
    productId: string;
    rating: number;
    text: string;
}): Promise<void> => {
    await apiClient('/review', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
    });
};

export const adminLogin = async (credentials: {
    login: string;
    password: string;
}): Promise<{ token: string }> => {
    const data = await apiClient<{ token: string }>('/admin/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
    });
    return data;
};

export const fetchAdminProducts = async (): Promise<{
    forsaleCount: number;
    archiveCount: number;
    products: adminProduct[];
}> => {
    const data = await apiAdminClient<{
        forsaleCount: number;
        archiveCount: number;
        products: adminProduct[];
    }>('/admin/products');

    return {
        forsaleCount: data.forsaleCount,
        archiveCount: data.archiveCount,
        products: data.products,
    };
};

export const updateProductStatus = async (
    productData: Partial<{
        productId: string;
        status: string;
    }>
): Promise<adminProduct> => {
    const data = await apiAdminClient<{ product: adminProduct }>(`/product/status/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData),
    });
    return data.product;
};

export const deleteProduct = async (id: string): Promise<void> => {
    await apiAdminClient(`/product/${id}`, {
        method: 'DELETE',
    });
};

export const addProduct = async (formData: FormData): Promise<adminProduct> => {
    const data = await apiAdminClient<{ product: adminProduct }>('/product', {
        method: 'POST',
        body: formData,
    });
    return data.product;
};

export const fetchAdminProductById = async (id: string): Promise<ProductDetail> => {
    const data = await apiAdminClient<{ product: ProductDetail }>(`/admin/product/${id}`);
    return data.product;
};

export const deleteImage = async (id: string): Promise<void> => {
    await apiAdminClient(`/image/${id}`, {
        method: 'DELETE',
    });
};

export type ImageItem = { id: string; url: string };

export const uploadImage = async (formData: FormData): Promise<ImageItem[]> => {
    const data = await apiAdminClient<{ images: ImageItem[] }>('/image/upload', {
        method: 'POST',
        body: formData,
    });
    return data.images;
};

export const deleteVideo = async (id: string): Promise<void> => {
    await apiAdminClient(`/video/${id}`, {
        method: 'DELETE',
    });
};

export type VideoItem = { id: string; url: string };

export const uploadVideo = async (formData: FormData): Promise<VideoItem[]> => {
    const data = await apiAdminClient<{ videos: VideoItem[] }>('/video/upload', {
        method: 'POST',
        body: formData,
    });
    return data.videos;
};

export const updateVideo = async (UpdateVideoItem: {
    id: string;
    title: string;
    demo: boolean;
}): Promise<void> => {
    await apiAdminClient('/video', {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(UpdateVideoItem),
    });
};

export const updateProduct = async (updateProductItem: {
    id: string;
    title: string;
    author: string;
    price: number;
    discount: number | null;
    description: string;
}): Promise<void> => {
    await apiAdminClient('/product', {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateProductItem),
    });
};

// export const fetchAdminDashboard = async (): Promise<{
//     totalProducts: number;
//     totalUsers: number;
//     recentOrders: any[];
// }> => {
//     const data = await apiClient<{
//         totalProducts: number;
//         totalUsers: number;
//         recentOrders: any[];
//     }>('/admin/dashboard');
//     return data;
// };
//
// export const createProduct = async (productData: {
//     title: string;
//     description: string;
//     price: number;
//     images: string[];
// }): Promise<Product> => {
//     const data = await apiClient<{ product: Product }>('/admin/products', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(productData),
//     });
//     return data.product;
// };
//
